// especialidades.js
//
// Especialidades médicas de Chile para la pregunta "De qué especialidad" del alta (#1738, R3):
// las primarias y las derivadas que reconoce CONACEM (Corporación Nacional Autónoma de
// Certificación de Especialidades Médicas). El listado es una AYUDA para escribir, no una
// validación: quien no aparece escribe la suya y se guarda tal cual (decisión de Sebastián,
// 18-oct-2026: "especialidad fuera de la lista = se guarda lo que escribió"). Por eso el
// backend (`especialidad`, hasta 120 caracteres) no la compara con esta lista.
// Cubre R3 — .claude/specs/1738-etapa-alta/

export const ESPECIALIDADES = [
  "Anatomía patológica",
  "Anestesiología",
  "Cardiología",
  "Cardiología pediátrica",
  "Cirugía cardiovascular",
  "Cirugía de cabeza, cuello y maxilofacial",
  "Cirugía de tórax",
  "Cirugía digestiva",
  "Cirugía general",
  "Cirugía pediátrica",
  "Cirugía plástica y reparadora",
  "Cirugía vascular periférica",
  "Coloproctología",
  "Dermatología",
  "Diabetología",
  "Endocrinología",
  "Endocrinología pediátrica",
  "Enfermedades respiratorias de adultos",
  "Enfermedades respiratorias pediátricas",
  "Gastroenterología",
  "Gastroenterología pediátrica",
  "Genética clínica",
  "Geriatría",
  "Ginecología oncológica",
  "Hematología",
  "Hematología oncológica pediátrica",
  "Hematología pediátrica",
  "Imagenología",
  "Infectología",
  "Infectología pediátrica",
  "Inmunología y alergología",
  "Laboratorio clínico",
  "Medicina de urgencia",
  "Medicina del trabajo",
  "Medicina familiar",
  "Medicina física y rehabilitación",
  "Medicina intensiva adulto",
  "Medicina intensiva pediátrica",
  "Medicina interna",
  "Medicina legal",
  "Medicina materno fetal",
  "Medicina nuclear",
  "Medicina paliativa",
  "Medicina reproductiva",
  "Nefrología",
  "Nefrología pediátrica",
  "Neonatología",
  "Neurocirugía",
  "Neurología",
  "Neurología pediátrica",
  "Neuroradiología",
  "Nutriología",
  "Obstetricia y ginecología",
  "Oftalmología",
  "Oncología médica",
  "Oncología pediátrica",
  "Ortopedia y traumatología",
  "Otorrinolaringología",
  "Patología clínica",
  "Pediatría",
  "Psiquiatría adultos",
  "Psiquiatría pediátrica y de la adolescencia",
  "Radioterapia oncológica",
  "Reumatología",
  "Reumatología pediátrica",
  "Salud pública",
  "Uroginecología",
  "Urología",
  "Urología pediátrica",
];

// Sin tildes ni mayúsculas: "cardio" y "CARDIÓ" encuentran lo mismo.
export const sinTildes = (t) =>
  String(t == null ? "" : t)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

// Las que empiezan con lo escrito primero y después las que lo contienen (así "card" muestra
// Cardiología antes que Cirugía cardiovascular, como el mockup). Sin texto no filtra nada:
// devuelve [] y el desplegable se cierra.
// «u de ch» encuentra «Universidad de Chile»: cada palabra escrita es el comienzo de una palabra del
// nombre, en el mismo orden.
const palabrasEnOrden = (nombre, q) => {
  const palabras = nombre.split(/\s+/);
  let i = 0;
  return q.split(/\s+/).every((t) => {
    while (i < palabras.length && !palabras[i].startsWith(t)) i += 1;
    if (i >= palabras.length) return false;
    i += 1;
    return true;
  });
};

export const filtrarOpciones = (lista, texto, tope = 8) => {
  const q = sinTildes(texto);
  if (!q) return [];
  const empiezan = [];
  const iniciales = [];
  const contienen = [];
  lista.forEach((e) => {
    const n = sinTildes(e);
    if (n.startsWith(q)) empiezan.push(e);
    // Las iniciales que arrancan en la primera palabra («u de ch» → Universidad de Chile) van antes
    // que las que solo calzan más adentro («Pontificia Universidad Católica de Chile»).
    else if (palabrasEnOrden(n, q) && n.startsWith(q.split(/\s+/)[0])) iniciales.push(e);
    else if (n.includes(q) || palabrasEnOrden(n, q)) contienen.push(e);
  });
  // Entre las iniciales, el nombre más corto primero: «u de ch» → «Universidad de Chile» antes que «… Austral de Chile».
  iniciales.sort((a, b) => a.length - b.length);
  return [...empiezan, ...iniciales, ...contienen].slice(0, tope);
};

export const filtrarEspecialidades = (texto, tope = 8) => filtrarOpciones(ESPECIALIDADES, texto, tope);
